import axios from '@/libs/api.request';

export const getMySaleApproveList = data => {
    return axios.request({
        url: 'api/saleManagement/saleApprove/getMySaleApproveList',
        data: data,
        method: 'post'
    });
};

export const getUnSaleApproveProductList = data => {
    return axios.request({
        url: 'api/saleManagement/saleApprove/getUnApproveProductList',
        data: data,
        method: 'post'
    });
};

export const saveApproveProduct = data => {
    return axios.request({
        url: 'api/saleManagement/saleApprove/saveApproveProduct',
        data: data,
        method: 'post'
    });
};

export const saveApproveResult = data => {
    return axios.request({
        url: 'api/saleManagement/saleApprove/saveApproveResult',
        data: data,
        method: 'post'
    });
};

export const getSaleApproveCategoryList = data => {
    return axios.request({
        url: 'api/saleManagement/saleApproveCategory/getSaleApproveCategoryList',
        data: data,
        method: 'post'
    });
};

export const getUnApproveCategoryList = data => {
    return axios.request({
        url: 'api/saleManagement/saleApproveCategory/getUnApproveCategoryList',
        data: data,
        method: 'post'
    });
};

export const deleteApproveCategory = data => {
    return axios.request({
        url: 'api/saleManagement/saleApproveCategory/deleteApproveCategory',
        data: data,
        method: 'post'
    });
};

export const saveApproveCategory = data => {
    return axios.request({
        url: 'api/saleManagement/saleApproveCategory/saveApproveCategory',
        data: data,
        method: 'post'
    });
};

export const webCurSaleProductList = data => {
    return axios.request({
        url: 'web/curSaleManagement/shopping/webCurSaleProductList',
        data: data,
        method: 'post'
    });
};

export const webGetShoppingCartList = data => {
    return axios.request({
        url: 'web/combine/shopping/webGetShoppingCartList',
        data: data,
        method: 'post'
    });
};

export const webCurSaleRemoveFromCart = data => {
    return axios.request({
        url: 'web/curSaleManagement/shopping/webCurSaleRemoveFromCart',
        data: data,
        method: 'post'
    });
};

export const webPreSaleRemoveFromCart = data => {
    return axios.request({
        url: 'web/preSaleManagement/preSalePlan/webPreSaleRemoveFromCart',
        data: data,
        method: 'post'
    });
};

export const webGetContract = data => {
    return axios.request({
        url: 'web/combine/shopping/webGetContract',
        data: data,
        method: 'post'
    });
};

export const webSubmitToOrderByManager = data => {
    return axios.request({
        url: 'web/combine/shopping/webSubmitToOrder',
        data: data,
        method: 'post'
    });
};

export const getCustomerManagerRelateCustomerUser = data => {
    return axios.request({
        url: 'api/saleManagement/saleHelpPutToCart/getCustomerManagerRelateCustomerUser',
        data: data,
        method: 'post'
    });
};

export const webGetMemberDeliveryAddressByUserId = data => {
    return axios.request({
        url: 'web/systemManagement/memberManagement/deliveryAddress/webGetMemberDeliveryAddressByUserId',
        data: data,
        method: 'post'
    });
};

export const webGetMemberDeliveryAddressByUserIdExt = data => {
    return axios.request({
        url: 'web/systemManagement/memberManagement/deliveryAddress/webGetMemberDeliveryAddressByUserIdExt',
        data: data,
        method: 'post'
    });
};

export const getDepositBillInfoByRecordUuid = data => {
    return axios.request({
        url: 'api/preSaleManagement/deposit/getAppDepositBillInfo',
        data: data,
        method: 'post'
    });
};

export const getUserDepositBillInfoListBySendProDate = data => {
    return axios.request({
        url: 'api/preSaleManagement/deposit/getAppDepositBillInfoList',
        data: data,
        method: 'post'
    });
};

export const getDepositBillListByDepositPaidList = data => {
    return axios.request({
        url: 'api/preSaleManagement/deposit/getDepositBillListByDepositPaidList',
        data: data,
        method: 'post'
    });
};

export const updateDepositBillRecordForDepositMoney = data => {
    return axios.request({
        url: 'api/preSaleManagement/deposit/updateDepositBillRecordForDepositMoney',
        data: data,
        method: 'post'
    });
};

export const webPreSaleDepositPayWithFund = data => {
    return axios.request({
        url: 'web/preSaleManagement/order/webPreSaleDepositPayWithFund',
        data: data,
        method: 'post'
    });
};

export const submitDepositBillRecord = data => {
    return axios.request({
        url: 'api/preSaleManagement/deposit/submitDepositBillRecord',
        data: data,
        method: 'post'
    });
};

export const getProductPreSalePlanList = data => {
    return axios.request({
        url: 'api/saleManagement/saleHelpPutToCart/getProductPreSalePlanList',
        data: data,
        method: 'post'
    });
};

export const submitPreSaleCart = data => {
    return axios.request({
        url: 'web/combine/shopping/webSubmitToOrder',
        data: data,
        method: 'post'
    });
};

export const webSubmitToOrderBatch = data => {
    return axios.request({
        url: 'web/combine/shopping/webSubmitToOrderBatch',
        data: data,
        method: 'post'
    });
};

export const savePreSaleOrderDetailSort = data => {
    return axios.request({
        url: 'web/combine/shopping/savePreSaleOrderDetailSort',
        data: data,
        method: 'post'
    });
};

export const getProductCurSaleList = data => {
    return axios.request({
        url: 'api/saleManagement/saleHelpPutToCart/getProductCurSaleList',
        data: data,
        method: 'post'
    });
};

export const submitCurSaleCart = data => {
    return axios.request({
        url: 'api/saleManagement/saleHelpPutToCart/submitCurSaleCart',
        data: data,
        method: 'post'
    });
};

export const webGetWeekConfig = data => {
    return axios.request({
        url: 'web/preSaleManagement/preSalePlan/webGetWeekConfig',
        data: data,
        method: 'post'
    });
};

export const getPreSaleOrderList = data => {
    return axios.request({
        url: 'api/preSaleManagement/order/getAppPreSaleOrderList',
        data: data,
        method: 'post'
    });
};

export const getProductPromotionList = data => {
    return axios.request({
        url: 'api/productManagement/Promotion/getProductPromotionList',
        data: data,
        method: 'post'
    });
};

export const getCustomerPromotionList = data => {
    return axios.request({
        url: 'api/productManagement/Promotion/getCustomerPromotionList',
        data: data,
        method: 'post'
    });
};

export const webSubmitToOrder = data => {
    return axios.request({
        url: 'web/combine/shopping/webSubmitToOrder',
        data: data,
        method: 'post'
    });
};

export const closePreSaleOrder = data => {
    return axios.request({
        url: 'api/preSaleManagement/order/closePreSaleOrder',
        data: data,
        method: 'post'
    });
};

export const savePreSaleOrderInfo = data => {
    return axios.request({
        url: 'api/preSaleManagement/deposit/savePreSaleOrderInfo',
        data: data,
        method: 'post'
    });
};

export const getAllProductList = data => {
    return axios.request({
        url: 'web/product/getAllProductList',
        data: data,
        method: 'post'
    });
};

export const getSeedFarmDeliveryWeek = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/getSeedFarmDeliveryWeek',
        data: data,
        method: 'post'
    });
};

export const webGetPreSaleProductList = data => {
    return axios.request({
        url: 'web/preSaleManagement/preSalePlan/webGetPreSaleProductList',
        data: data,
        method: 'post'
    });
};

export const getPreSaleProductInfo = data => {
    return axios.request({
        url: 'web/product/getPreSaleProductInfo',
        data: data,
        method: 'post'
    });
};

export const getCompensationList = data => {
    return axios.request({
        url: 'api/saleManagement/compensation/getCompensationList',
        data: data,
        method: 'post'
    });
};

export const saveCompensation = data => {
    return axios.request({
        url: 'api/saleManagement/compensation/saveCompensation',
        data: data,
        method: 'post'
    });
};

export const cancelCompensation = data => {
    return axios.request({
        url: 'api/saleManagement/compensation/cancelCompensation',
        data: data,
        method: 'post'
    });
};

export const getSaleOrderDetailByCode = data => {
    return axios.request({
        url: 'api/saleManagement/compensation/getSaleOrderDetailByCode',
        data: data,
        method: 'post'
    });
};


export const getSaleOrderDetailByCodeAnduserCustomerManager = data => {
    return axios.request({
        url: 'api/saleManagement/compensation/getSaleOrderDetailByCodeAnduserCustomerManager',
        data: data,
        method: 'post'
    });
};


export const getComplainList = data => {
    return axios.request({
        url: 'api/saleManagement/Complain/getComplainList',
        data: data,
        method: 'post'
    });
};

export const responseComplain = data => {
    return axios.request({
        url: 'api/saleManagement/Complain/responseComplain',
        data: data,
        method: 'post'
    });
};

export const getMemberDetailInfo = data => {
    return axios.request({
        url: 'web/systemManagement/memberManagement/memberInfo/webGetMemberUserDetail',
        data: data,
        method: 'post'
    });
};

export const getPaymentChannel = data => {
    return axios.request({
        url: 'api/systemManagement/systemSetting/getPaymentChannel',
        data: data,
        method: 'post'
    });
};

export const createABCWeixin = data => {
    return axios.request({
        url: 'web/paymentManagemenbt/ABCPay/createABCWeixin',
        data: data,
        method: 'post'
    });
};

export const createABCAliPay = data => {
    return axios.request({
        url: 'web/paymentManagemenbt/ABCPay/createABCAliPay',
        data: data,
        method: 'post'
    });
};

export const getPayPlatformConfigList = data => {
    return axios.request({
        url: 'api/systemManagement/payPlatformManagement/getPayPlatformConfigList',
        data: data,
        method: 'post'
    });
};

export const createCMBPay = data => {
    return axios.request({
        url: 'web/paymentManagemenbt/CMBPay/createCMBPay',
        data: data,
        method: 'post'
    });
};

export const createCCBCPay = data => {
    return axios.request({
        url: 'web/paymentManagemenbt/CCBCPay/createCCBCPay',
        data: data,
        method: 'post'
    });
};


export const createWeiXinPay = data => {
    return axios.request({
        url: 'web/paymentManagemenbt/WeiXin/createWeiXinPay',
        data: data,
        method: 'post'
    });
};

export const createAliPay = data => {
    return axios.request({
        url: 'web/paymentManagemenbt/AliPay/createAliPay',
        data: data,
        method: 'post'
    });
};

export const QueryABCPay = data => {
    return axios.request({
        url: 'web/paymentManagemenbt/ABCPay/QueryABCPay',
        data: data,
        method: 'post'
    });
};

export const QueryCMBPay = data => {
    return axios.request({
        url: 'web/paymentManagemenbt/CMBPay/QueryCMBPay',
        data: data,
        method: 'post'
    });
};
export const QueryCCBCPay = data => {
    return axios.request({
        url: 'web/paymentManagemenbt/CCBCPay/QueryCCBCPay',
        data: data,
        method: 'post'
    });
};
export const queryWeiXinPay = data => {
    return axios.request({
        url: 'web/paymentManagemenbt/WeiXin/queryWeiXinPay',
        data: data,
        method: 'post'
    });
};

export const queryAliPay = data => {
    return axios.request({
        url: 'web/paymentManagemenbt/AliPay/queryAliPay',
        data: data,
        method: 'post'
    });
};

export const getUserInfoByUuid = data => {
    return axios.request({
        url: 'web/systemManagement/memberManagement/memberInfo/getUserInfoByUuid',
        data: data,
        method: 'post'
    });
};
//审核退款单
export const onSaveApproveResult = data => {
    return axios.request({
        url: 'api/saleManagement/compensation/saveApproveResult',
        data: data,
        method: 'post'
    });
};
